import React, { useState } from 'react';
import { X, Users, Check } from 'lucide-react';
import './CreateGroupModal.css';

const EMOJI_OPTIONS = ['👥', '🚀', '⭐', '💼', '🎯', '📊', '🔧', '💡', '🌟', '🎨'];

const CreateGroupModal = ({ agents, onClose, onCreate }) => {
  const [groupName, setGroupName] = useState('');
  const [groupAvatar, setGroupAvatar] = useState('👥');
  const [groupDescription, setGroupDescription] = useState('');
  const [selectedAgents, setSelectedAgents] = useState([]);

  const handleToggleAgent = (agentId) => {
    setSelectedAgents(prev => 
      prev.includes(agentId)
        ? prev.filter(id => id !== agentId)
        : [...prev, agentId]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!groupName.trim()) {
      alert('Please enter a group name');
      return;
    }

    if (selectedAgents.length === 0) {
      alert('Please select at least one agent');
      return;
    }

    onCreate({
      name: groupName,
      avatar: groupAvatar,
      description: groupDescription,
      selectedAgents
    });
  };

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="create-group-modal">
        <div className="modal-header">
          <div className="modal-title">
            <Users size={20} />
            <span>Create New Group</span>
          </div>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-content">
          <div className="form-group">
            <label className="form-label">Group Avatar</label>
            <div className="avatar-selector">
              {EMOJI_OPTIONS.map(emoji => (
                <button
                  key={emoji}
                  type="button"
                  className={`avatar-option ${groupAvatar === emoji ? 'selected' : ''}`}
                  onClick={() => setGroupAvatar(emoji)}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Group Name *</label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., Project Team, Marketing Group"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea
              className="form-textarea"
              placeholder="What's this group about?"
              value={groupDescription}
              onChange={(e) => setGroupDescription(e.target.value)}
              rows={2}
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              Select Members ({selectedAgents.length} selected)
            </label>
            <div className="members-list">
              <div className="member-item user-member">
                <div className="member-avatar">👤</div>
                <div className="member-info">
                  <div className="member-name">You</div>
                  <div className="member-role">Group Creator</div>
                </div>
                <div className="member-badge">Owner</div>
              </div>

              {agents.map(agent => (
                <div
                  key={agent.id}
                  className={`member-item ${selectedAgents.includes(agent.id) ? 'selected' : ''}`}
                  onClick={() => handleToggleAgent(agent.id)}
                >
                  <div className="member-avatar">{agent.avatar}</div>
                  <div className="member-info">
                    <div className="member-name">{agent.name}</div>
                    <div className="member-role">{agent.description}</div>
                  </div>
                  <div className="member-checkbox">
                    {selectedAgents.includes(agent.id) && <Check size={16} />}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="modal-button cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="modal-button create-button"
              disabled={!groupName.trim() || selectedAgents.length === 0}
            >
              Create Group
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateGroupModal;